/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FreeNightCredit } from './FreeNightCredit';
import {
    FreeNightCreditFromJSON,
    FreeNightCreditFromJSONTyped,
    FreeNightCreditToJSON,
    FreeNightCreditToJSONTyped,
} from './FreeNightCredit';

/**
 * 
 * @export
 * @interface FreeNightCreditsResponse
 */
export interface FreeNightCreditsResponse {
    /**
     * 
     * @type {Array<FreeNightCredit>}
     * @memberof FreeNightCreditsResponse
     */
    credits: Array<FreeNightCredit>;
}

/**
 * Check if a given object implements the FreeNightCreditsResponse interface.
 */
export function instanceOfFreeNightCreditsResponse(value: object): value is FreeNightCreditsResponse {
    if (!('credits' in value) || value['credits'] === undefined) return false;
    return true;
}

export function FreeNightCreditsResponseFromJSON(json: any): FreeNightCreditsResponse {
    return FreeNightCreditsResponseFromJSONTyped(json, false);
}

export function FreeNightCreditsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreeNightCreditsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'credits': ((json['credits'] as Array<any>).map(FreeNightCreditFromJSON)),
    };
}

export function FreeNightCreditsResponseToJSON(json: any): FreeNightCreditsResponse {
    return FreeNightCreditsResponseToJSONTyped(json, false);
}

export function FreeNightCreditsResponseToJSONTyped(value?: FreeNightCreditsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'credits': ((value['credits'] as Array<any>).map(FreeNightCreditToJSON)),
    };
}

